import React from 'react'
import './Categories.css'

export const Categories = () => {
  return (
    <div>Categories</div>
  )
}
